import {
  DistributedProject,
  GET_DETAIL_PROJECTS_ATMNHA,
  GetDetailProjectsATMNhaData,
  GetDetailProjectsATMNhaVariables,
} from 'graphql/main/queries';
import { useFlexQuery, useScroll } from 'hooks';
import { gt, isString } from 'lodash';
import dynamic from 'next/dynamic';
import { DetailProjectPageContext } from 'pages/du-an/[chi-tiet-du-an]';
import { Context, Fragment, createContext, useContext } from 'react';
import Footer from '../shared/footer';
import Header2 from '../shared/header2';
import Gallery from './gallery';
import MainSection from './main-section';
import Navbar from './navbar';
import Overview from './overview';
import RelatedCardList from './related-card-list';

const BlockInformation = dynamic(() => import('./block-information'), { ssr: false });

export const DetailProjectPageClientContext: Context<Props> = createContext({});

interface Props {
  pageData?: {
    project?: DistributedProject;
  };
}

const DetailProject = () => {
  const { position } = useScroll();
  const isScrolled = gt(position, 900);
  const { project } = useContext(DetailProjectPageContext).pageData ?? {};
  const { id } = project ?? {};
  const { data: getDetailProjectsATMNhaData } = useFlexQuery<
    GetDetailProjectsATMNhaData,
    GetDetailProjectsATMNhaVariables
  >('main', GET_DETAIL_PROJECTS_ATMNHA, {
    variables: {
      id: isString(id) ? id : '',
    },
    skip: !id,
  });
  const { getDetailProjectsATMNha: projectClient } = getDetailProjectsATMNhaData ?? {};

  return (
    <Fragment>
      {isScrolled ? (
        <Navbar />
      ) : (
        <div className='relative'>
          <Header2 />
        </div>
      )}
      <DetailProjectPageClientContext.Provider
        value={{
          pageData: {
            project: projectClient,
          },
        }}
      >
        <main className='flex min-h-[1000px] min-w-[1052px] flex-col'>
          <div className='my-[28px] flex flex-col space-y-[28px]'>
            <Gallery />
            <Overview />
            <BlockInformation />
            <MainSection />
            <RelatedCardList />
          </div>
        </main>
      </DetailProjectPageClientContext.Provider>
      <Footer />
    </Fragment>
  );
};

export default DetailProject;
